/* eslint-disable @typescript-eslint/no-explicit-any */
import { useStore } from '@/containers'
import { IconClose } from '@/styles/Icon'
import { Dialog, Transition } from '@headlessui/react'
import type { Dispatch, SetStateAction } from 'react'
import { Fragment } from 'react'
import { MegaMenu } from '../MegaMenu/MegaMenu'

interface ModalMegaMenu {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}
const ModalMegaMenu = ({ open, setOpen }: ModalMegaMenu) => {
  const { megaMenu } = useStore()
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as='div' className='relative z-[9999]' onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter='ease-in-out duration-500'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in-out duration-500'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 left-0 bg-gray-500 bg-opacity-75 transition-opacity' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-hidden'>
          <div className='pointer-events-none fixed inset-y-0 left-1/2 -translate-x-1/2 flex max-w-[440px]'>
            <Transition.Child
              as={Fragment}
              enter='transform transition ease-in-out duration-500 sm:duration-700'
              enterFrom='-translate-x-[100%] opacity-0'
              enterTo='translate-x-[0%] opacity-100'
              leave='transform transition ease-in-out duration-500 sm:duration-700'
              leaveFrom='translate-x-[0%] opacity-100'
              leaveTo='-translate-x-[100%] opacity-0'
            >
              <Dialog.Panel className='pointer-events-auto w-screen max-w-md'>
                <div className='flex h-full flex-col bg-white relative'>
                  <div className='w-full px-2 pb-3 pt-5 border-b-4 border-white-500'>
                    <h2 className='text-lg font-semibold text-dark-900'>
                      Danh mục sản phẩm
                    </h2>
                  </div>
                  <span
                    className='absolute block right-2 z-10 top-5'
                    onClick={() => setOpen(false)}
                  >
                    <IconClose />
                  </span>
                  <MegaMenu
                    megaMenuData={megaMenu}
                    closeModal={() => setOpen(false)}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default ModalMegaMenu
